import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "moduleId", "form", "title"]

  open(event) {
    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const moduleId = trigger?.dataset?.moduleId
    const formAction = trigger?.dataset?.formAction
    const formMethod = trigger?.dataset?.formMethod
    const formFields = trigger?.dataset?.formFields
    const modalTitle = trigger?.dataset?.modalTitle

    const form = this.hasFormTarget ? this.formTarget : this.dialogTarget.querySelector("form")
    if (form) {
      // Snapshot the create action once so an edit doesn't leave the form on the edit URL next open.
      if (this.defaultAction === undefined) {
        this.defaultAction = form.getAttribute("action")
      }
      form.reset()
      form.action = formAction || this.defaultAction
      this.applyMethod(form, formMethod)
      this.applyFields(form, formFields)
    }

    if (this.hasModuleIdTarget && moduleId) {
      this.moduleIdTarget.value = moduleId
    }

    if (this.hasTitleTarget) {
      const fallbackTitle = this.titleTarget.dataset.defaultTitle || this.titleTarget.textContent
      this.titleTarget.textContent = modalTitle || fallbackTitle
    }

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  closeOnSuccess(event) {
    if (event.detail.success) {
      this.close()
    }
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }

  applyMethod(form, method) {
    const normalized = (method || "").toLowerCase()
    const existing = form.querySelector("input[name='_method']")

    if (!normalized || normalized === "post") {
      if (existing) {
        existing.remove()
      }
      return
    }

    if (existing) {
      existing.value = normalized
      return
    }

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = normalized
    form.appendChild(methodInput)
  }

  applyFields(form, fields) {
    if (!fields) {
      return
    }

    let parsed = null
    try {
      parsed = JSON.parse(fields)
    } catch {
      parsed = null
    }

    if (!parsed) {
      return
    }

    Object.entries(parsed).forEach(([key, value]) => {
      const input = form.querySelector(`[name="variable_group[${key}]"]`)
      if (!input) {
        return
      }

      if (input.type === "checkbox") {
        input.checked = Boolean(value)
      } else {
        input.value = value == null ? "" : String(value)
      }
    })
  }
}
